export const inputError = (state = {}, action) => {
  if (action.type === "FIELD_ERROR") {
    return { ...state, [action.field]: action.message };
  } else if (action.type === "START_SUBMIT") {
    return {};
  }

  return state;
};
